export function bestDealOfferHeading(input: {
  presentationScope: "release" | "work";
  matchesContextRelease: boolean;
  hasContextRelease: boolean;
  siblingFormat: string;
  offerForThisEdition: string;
  bestOffer: string;
  otherEdition: string;
  lowestCurrentPriceAcrossEditions: string;
}): string {
  if (input.presentationScope === "work") return input.lowestCurrentPriceAcrossEditions;
  if (!input.matchesContextRelease) return `${input.otherEdition} · ${input.siblingFormat}`;
  return input.hasContextRelease ? input.offerForThisEdition : input.bestOffer;
}
